import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import React from 'react'

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: theme.maxWidth,
    margin: '0 auto',
    padding: theme.spacing(2, 2, 4),
    [theme.breakpoints.up('mobile')]: {
      paddingTop: theme.spacing(4),
    },
  },
  backLink: {
    paddingTop: theme.spacing(1.5),
  },
  muiTable: {
    paddingTop: theme.spacing(1.75),
  },
  sizeSm: {
    maxWidth: 600,
  },
}))

const Container = ({ className, backLink, children, maxWidth, muiTable }) => {
  const classes = useStyles()
  return (
    <div
      className={clsx(
        classes.root,
        {
          [classes.muiTable]: muiTable,
          [classes.backLink]: backLink,
          [classes.sizeSm]: maxWidth === 'sm',
        },
        className
      )}
    >
      {children}
    </div>
  )
}

export default Container
